import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101232 56777"
    {...props}
  >
    <path
      d="M54279 17127c7092 0 13585 3275 17818 8981 522 707 1419 1030 2270 816 1392-347 2821-523 4251-523 9672-1 17533 7866 17533 17533 0 2696-622 5358-1811 7761H14424c-923-1778-1410-3753-1410-5773 0-6930 5636-12566 12564-12566 1586 0 3137 296 4611 877 562 221 1195 199 1742-65 549-264 958-743 1134-1326 2857-9398 11381-15715 21214-15715zM20850 5076c8254 0 15036 6378 15707 14463-2989 2684-5383 6060-6927 9964-1318-329-2674-493-4052-493-4948 0-9395 2152-12490 5554-4775-2712-8010-7840-8010-13714 0-8696 7076-15772 15772-15774zM734 20850c0 7343 3954 13781 9846 17290-1212 2333-1911 4974-1911 7782 2 3241 926 6398 2675 9122 399 622 1090 1000 1830 1000l82462-2c770 0 1485-409 1872-1074 1959-3342 2990-7157 2990-11034 0-12062-9817-21878-21880-21878-1305-2-2615 117-3904 350-5013-6049-12551-9624-20437-9624-5009 0-9724 1385-13762 3828C38562 7546 30487 734 20850 734 9758 734 732 9757 734 20850z"
      style={{
        fill: "#322d2c",
        // stroke: "#000",
        strokeWidth: 1467.15,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
